import { useMemo } from "react";
import { useHistory } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";
import useDecodeToken from "../../../../hooks/useDecodeToken";

import { getOrderHistorySearch } from "../../../../services/deliveryService";

import { orderSearchCategories } from "../../../../constants";
import {
  checkIfClient,
  API_CONSTANTS,
  retryAttempt,
  queryKeys,
  RENDER_MODE,
  addPendingReturnOrderStatus,
} from "../constants";

const useSSROrders = ({
  searchCategory,
  fromDate,
  toDate,
  columnsFilter = [],
  columnsSorting = [],
  pageIndex = 0,
  pageSize = 10,

  invoices = [],
  barcodes = [],
  referenceNos = [],

  isServerSide = true,
}) => {
  const [decodedToken] = useDecodeToken();
  const history = useHistory();
  // const queryClient = useQueryClient();

  const isClient = useMemo(() => checkIfClient(decodedToken), [decodedToken]);

  const searchOrderHistoryParams = useMemo(() => {
    const baseParams = {
      searchBy: searchCategory,
      isClient,
      pageIndex,
      pageSize,
      columnsFilter,
      columnsSorting,
    };

    if (searchCategory === orderSearchCategories.dateRange.value) {
      return {
        ...baseParams,
        fromDate,
        toDate,
      };
    }

    if (searchCategory === orderSearchCategories.invoice.value) {
      return {
        ...baseParams,
        selected: invoices,
      };
    }

    if (searchCategory === orderSearchCategories.barcode.value) {
      return {
        ...baseParams,
        selected: barcodes,
      };
    }

    if (searchCategory === orderSearchCategories.refNo.value) {
      return {
        ...baseParams,
        selected: referenceNos,
      };
    }
  }, [
    searchCategory,
    isClient,
    fromDate,
    toDate,
    pageIndex,
    pageSize,
    columnsFilter,
    columnsSorting,
    invoices,
    barcodes,
    referenceNos,
  ]);

  // const queryClient = useQueryClient();
  const deliveryHistorQuery = useQuery({
    queryKey: queryKeys.DELIVERY_HISTORY_BY(
      searchCategory,
      searchOrderHistoryParams,
    ),
    queryFn: () =>
      getOrderHistorySearch({
        ...searchOrderHistoryParams,
        timeout: API_CONSTANTS.TIMEOUT,
        tableMode: RENDER_MODE.SSR,
        skipCXTStatus: true,
      }),
    retry: retryAttempt,
    // select: (response) => response?.data,
    select: (response) => {
      const { deliveryList, returnRequestList } = response?.data || {};

      const deliveryListWithReturnStatus = addPendingReturnOrderStatus(
        deliveryList,
        returnRequestList,
      );

      return {
        ...response?.data,
        deliveryList: deliveryListWithReturnStatus,
      };
    },

    meta: { history },
    staleTime: API_CONSTANTS.STALE_TIME,
    cacheTime: API_CONSTANTS.GC_TIME,
    keepPreviousData: true,
    enabled: isServerSide,
  });

  // useEffect(() => {
  //   const MAX_PAGES = Math.ceil(
  //     (deliveryHistorQuery?.data?.total || 0) / pageSize,
  //   );
  //   const currentPage = pageIndex;

  //   // prefetch next page if it exists
  //   if (currentPage < MAX_PAGES - 1 && MAX_PAGES > 1) {
  //     const nextPageIndex = currentPage + 1;

  //     queryClient.prefetchQuery({
  //       queryKey: queryKeys.DELIVERY_HISTORY_BY(searchCategory, {
  //         ...searchOrderHistoryParams,
  //         pageIndex: nextPageIndex,
  //       }),
  //       queryFn: () =>
  //         getOrderHistorySearch({
  //           ...searchOrderHistoryParams,
  //           pageIndex: nextPageIndex,
  //           timeout: API_CONSTANTS.TIMEOUT,
  //           tableMode: RENDER_MODE.SSR,
  //           shouldSkipCXTStatus: true,
  //         }),
  //       retry: retryAttempt,
  //       staleTime: API_CONSTANTS.STALE_TIME,
  //       cacheTime: API_CONSTANTS.GC_TIME,
  //       keepPreviousData: true,
  //       enabled: isServerSide,
  //     });
  //   }
  // }, [
  //   deliveryHistorQuery?.data?.total,
  //   pageIndex,
  //   pageSize,
  //   queryClient,
  //   searchCategory,
  //   isServerSide,
  //   searchOrderHistoryParams,
  // ]);

  return deliveryHistorQuery;
};

export default useSSROrders;
